import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Header from '../components/Header';
import Footer from '../components/Footer';

const BlogsPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/blogs`).then(r => { setBlogs(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <Header />

      <div className="container mx-auto px-4 py-12 pt-20">
        <div className="mb-12">
          <p className="text-xs uppercase tracking-[0.3em] font-bold text-secondary mb-2">Tea Journal</p>
          <h1 className="text-4xl font-black font-heading" data-testid="blogs-heading">Stories & Guides</h1>
        </div>

        {blogs.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-muted-foreground" data-testid="no-blogs-message">No articles yet. Check back soon!</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogs.map((blog) => (
              <div
                key={blog.blog_id}
                className="group cursor-pointer"
                onClick={() => navigate(`/blogs/${blog.slug}`)}
                data-testid={`blog-card-${blog.blog_id}`}
              >
                <div className="rounded-2xl overflow-hidden mb-4 aspect-video bg-white border border-[#E0E0E0]">
                  {blog.image_url ? (
                    <img src={blog.image_url} alt={blog.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  ) : (
                    <div className="w-full h-full bg-muted flex items-center justify-center text-muted-foreground">No Image</div>
                  )}
                </div>
                <p className="text-xs text-muted-foreground uppercase tracking-wider mb-2">{blog.author}</p>
                <h3 className="font-heading font-bold text-lg mb-2 group-hover:text-primary transition-colors">{blog.title}</h3>
                <p className="text-sm text-muted-foreground line-clamp-2">{blog.excerpt}</p>
              </div>
            ))}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default BlogsPage;
